import React, { Component } from "react";
import { connect } from "react-redux";
import "./experience.scss";
import util from "../../_helpers/util";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";
import { confirmAlert } from "react-confirm-alert";
import { config } from "../../_config/_config";
import MandatorySymbol from "../common/MandatorySymbol";

const step = 4;
const page = "experiences";
class Experience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canApply: true,
      form: {
        firestorm_experience: "no",
        no_past_experience: ["yes"],
        no_past_reference: ["yes"],
        step: step,
        reference1: "",
        reference2: "",
        reference3: "",
        seperation_reason: "",
        last_employer1: "",
        reference1Position: "",
        reference1StartDate: "",
        reference1EndDate: "",
        reference1Address: "",
        reference1City: "",
        reference1State: "",
        reference1Supervisor: "",
        reference1AltContact: "",
        reference1Telephone: "",
        reference1Fax: "",

        last_employer2: "",
        reference2Position: "",
        reference2StartDate: "",
        reference2EndDate: "",
        reference2Address: "",
        reference2City: "",
        reference2State: "",
        reference2Supervisor: "",
        reference2AltContact: "",
        reference2Telephone: "",
        reference2Fax: "",

        last_employer3: "",
        reference3Position: "",
        reference3StartDate: "",
        reference3EndDate: "",
        reference3Address: "",
        reference3City: "",
        reference3State: "",
        reference3Supervisor: "",
        reference3AltContact: "",
        reference3Telephone: "",
        reference3Fax: "",

        reference1name: "",
        reference1Relationship: "",
        reference1Phone: "",
        reference1Known: "",

        reference2name: "",
        reference2Relationship: "",
        reference2Phone: "",
        reference2Known: "",

        reference3name: "",
        reference3Relationship: "",
        reference3Phone: "",
        reference3Known: "",

        personalreference1: "",
        personalreference2: "",
        personalreference3: "",
      },
    };
  }

  blur(event) {
    util.blur(event);
  }

  setValue(event) {
    if (event.target.classList.contains("aplcn-has-error")) {
      event.target.classList.remove("aplcn-has-error");
    }
    util.setValue.call(this, event);
  }

  handleDateChange(name, date) {
    util.setValue.call(this, null, {
      value: date,
      name: name,
    });
  }
  submitForm(event) {
    event.preventDefault();
    if (!this.state.canApply) {
      confirmAlert({
        title: "Application Update Restricted",
        message: "You cannot update your job application as it may currently be under review or archived. Please email hqs@patrickfire.com if you believe this is incorrect.",
        buttons: [
          {
            label: "Close",
            onClick: () => { },
          },
        ],
      });
      return;
    }
    if (!util.forceVlidate(document.getElementById(page))) {
      return;
    }
    if (
      this.state.form.no_past_experience != "yes" &&
      !util.forceVlidate(event.currentTarget)
    ) {
      return;
    }

    const isCityEmptyRegEx = /^\s*$/;

    if (
      isCityEmptyRegEx.test(this.state.form.reference1City) ||
      isCityEmptyRegEx.test(this.state.form.reference2City)
    ) {
      return;
    }

    "function" === typeof this.props.action &&
      this.props.action({ ...this.state.form, step }, step);
  }
  componentDidMount() {
    this.setDefaultData();
    confirmAlert({
      title: "Application Requirement: Work History or References",
      message: (
        <div
          style={{
            maxHeight: '200px',
            overflowY: 'scroll',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <p style={{ fontSize: '0.85em', color: '#555', fontStyle: 'italic', marginBottom: '0.5em' }}>
            (Scroll to see full list)
          </p>
          <p>
            Past employment history must be filled out. Incomplete applications will
            automatically be rejected.
          </p>
          <p>
            For applicants just getting out of high school who have never had a job or only one job, etc., please provide other references if you do not have past employment history, which would include the list below, but not be limited to:
          </p>
          <ul style={{ marginBottom: 0 }}>
            <li>Teachers</li>
            <li>Guidance Counselor</li>
            <li>School Administrator</li>
            <li>Coach</li>
            <li>Club Advisor</li>
            <li>Religious Leaders</li>
            <li>Mentors</li>
            <li>Volunteer Supervisor</li>
            <li>Summer Program Coordinator</li>
          </ul>
        </div>

      ),
      buttons: [
        {
          label: "Close",
          onClick: () => { },
        },
      ],
    });
  }
  componentDidUpdate(prevProps) {
    const applicationDetails =
      this.props.api && this.props.api.aplicationDetail;
    const prevApplicationDetails =
      prevProps.api && prevProps.api.aplicationDetail;
    const shouldSetDefaultValues = !!(
      (applicationDetails && applicationDetails.hash) !==
      (prevApplicationDetails && prevApplicationDetails.hash)
    );

    if (shouldSetDefaultValues) {
      this.setDefaultData();
    }
  }

  setDefaultData() {
    if (this.props.api && this.props.api.aplicationDetail) {
      var data = this.props.api.aplicationDetail,
        obj = Object.assign({}, this.state.form);
      this.setState({
        canApply: data.can_apply,
        form: util._merge(
          obj,
          data,
          {
            firestorm_experience: "worked_for_firestorm",
            seperation_reason: "reason_leave_firestorm",
            reference1: "reference1",
            reference2: "reference2",
            reference3: "reference3",
            personalreference1: "personalreference1",
            personalreference2: "personalreference2",
            personalreference3: "personalreference3",
          },
          (res) => {
            return this.setReference(res);
          },
        ),
      });
    }
  }
  setReference(res) {
    var res = util.extractObjectAndMerge(
      res,
      {
        start_date: ["reference", "StartDate"],
        end_date: ["reference", "EndDate"],
        last_employee: "last_employer",
        city_id: ["reference", "City"],
        address: ["reference", "Address"],
        supervisor_name: ["reference", "Supervisor"],
        telephone: ["npm run startreference", "Telephone"],
        position: ["reference", "Position"],
        state_id: ["reference", "State"],
        fax: ["reference", "Fax"],
        alt_contact_name: ["reference", "AltContact"],
        responsibilities: ["reference", "Responsibilities"],
        reason_for_leaving: ["reference", "ResonForLeaving"],
        telephone: ["reference", "Telephone"],
      },
      ["reference1", "reference2", "reference3"],
    );
    res = util.extractObjectAndMerge(
      res,
      {
        name: ["reference", "name"],
        relationship: ["reference", "Relationship"],
        phone: ["reference", "Phone"],
        known: ["reference", "Known"],
      },
      ["personalreference1", "personalreference2", "personalreference3"],
    );
    return res;
  }

  render() {
    const firestormExp =
      this.props?.api?.aplicationDetail?.worked_for_firestorm;
    return (
      <div className="aplcn-form aplcn-form-one">
        <form method="post" onSubmit={this.submitForm.bind(this)} id={page}>
          <div className="aplcn-form-section-head">
            <h4>Professional References</h4>
          </div>

          <div className="aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">
              Have you worked for {config.companyName} in the past? <MandatorySymbol />
            </h5>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="firestorm_experience1"
                  onChange={this.setValue.bind(this)}
                  name="form.firestorm_experience"
                  checked={this.state.form.firestorm_experience === "yes"}
                  defaultChecked={firestormExp === "yes"}
                />
                <label htmlFor="firestorm_experience1">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="firestorm_experience3"
                  onChange={this.setValue.bind(this)}
                  name="form.firestorm_experience"
                  checked={this.state.form.firestorm_experience === "no"}
                  defaultChecked={firestormExp === "yes"}
                />
                <label htmlFor="firestorm_experience3">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>
          {"yes" === this.state.form.firestorm_experience && (
            <div>
              <div className="aplcn-form-section-head">
                <h4>
                  If Yes, what was the reason for separation? Who was your
                  supervisor?
                </h4>
              </div>
              <div className="aplcn-form-row-main">
                <input
                  type="text"
                  placeholder="If Yes, please explain…"
                  name="form.seperation_reason"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.seperation_reason}
                  title="Reason for Separation from Firestorm"
                />
              </div>
            </div>
          )}

          {/* No Past Experiences */}
          {/* <div className="aplcn-form-row-main pad-v-2">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="checkbox"
                  id="no_past_experience"
                  onChange={this.setValue.bind(this)}
                  name="form.no_past_experience"
                  defaultChecked={this.state.form.no_past_experience.length > 0}
                />
                <label htmlFor="no_past_experience">
                  <span className="aplcn-check-label">No Past Experience</span>
                </label>
              </li>
            </ul>
          </div> */}

          {/* Section 1 */}
          <div className="past-employer-section">
            <div className="aplcn-form-section-head">
              <h4>
                Past Experiences / Employment Record / References - #1{" "}
                <MandatorySymbol />
              </h4>
            </div>
            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    type="text"
                    required={true}
                    disabled={false}
                    placeholder="Past Employer"
                    name="form.last_employer1"
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.last_employer1}
                    title="Past Employer #1"
                  />
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    required={true}
                    disabled={false}
                    type="text"
                    placeholder="Position Held"
                    name="form.reference1Position"
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1Position}
                    title="Position at Past Experience #1"
                  />
                </div>
              </div>
            </div>

            <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <DatePicker
                    required={true}
                    disabled={false}
                    selected={this.state.form.reference1StartDate}
                    showYearDropdown
                    onChange={this.handleDateChange.bind(
                      this,
                      "form.reference1StartDate",
                    )}
                    placeholderText="Start Date MM/DD/YYYY"
                    dateFormat={util._datePickerFormat()}
                    maxDate={new Date()}
                    title="Start date of Past Experience #1"
                  />
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <DatePicker
                    required={true}
                    disabled={false}
                    selected={this.state.form.reference1EndDate}
                    showYearDropdown
                    onChange={this.handleDateChange.bind(
                      this,
                      "form.reference1EndDate",
                    )}
                    placeholderText="End Date MM/DD/YYYY"
                    dateFormat={util._datePickerFormat()}
                    minDate={this.state.form.reference1StartDate}
                    title="End date of Past Experience #1"
                  />
                </div>
              </div>
            </div>

            <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                  <input
                    type="text"
                    placeholder="Address"
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1Address}
                    name="form.reference1Address"
                    title="Location Address of Past Experience #1"
                  />
                </div>
                <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                  <input
                    type="text"
                    placeholder="City"
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1City}
                    name="form.reference1City"
                    title="Location City of Past Experience #1"
                  />
                </div>
                <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                  <input
                    type="text"
                    placeholder="State"
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1State}
                    name="form.reference1State"
                    title="Location State of Past Experience #1"
                  />
                </div>
              </div>
            </div>

            <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    type="text"
                    placeholder="Supervisors name"
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1Supervisor}
                    name="form.reference1Supervisor"
                    title="Supervisor at Past Experience #1"
                  />
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    type="text"
                    placeholder="Alternate contact name"
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1AltContact}
                    name="form.reference1AltContact"
                  />
                </div>
              </div>
            </div>

            <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <NumberFormat
                    placeholder="Cell Phone"
                    required={true}
                    disabled={false}
                    data-validation="phonenumber"
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    name="form.reference1Telephone"
                    value={this.state.form.reference1Telephone}
                    format="(###) ###-####"
                    mask=""
                    title="Cell Phone of employer at Past Experience #1"
                  />
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    type="text"
                    placeholder="Fax"
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1Fax}
                    name="form.reference1Fax"
                    data-validation="fax"
                    maxlength="20"
                  />
                </div>
              </div>
            </div>

            <div className="aplcn-form-section-head">
              <h4>Responsibilities</h4>
            </div>

            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap aplcn-note-text-wrapper">
                  <textarea
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1Responsibilities}
                    name="form.reference1Responsibilities"
                    placeholder="Please fill out your responsibilities for this position…"
                    title="Responsibilities at Past Experience #1"
                  />
                </div>
              </div>
            </div>

            <div className="aplcn-form-section-head">
              <h4>Reason For Leaving</h4>
            </div>

            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-12 aplcn-inp-wrap aplcn-note-text-wrapper">
                  <textarea
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1ResonForLeaving}
                    name="form.reference1ResonForLeaving"
                    placeholder="Please describe your reason for leaving…"
                    title="Reason for leaving employer of  Past Experience #1"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <!--section -2 --> */}

          {
            <div className="past-employer-section">
              <div className="aplcn-form-section-head">
                <h4>
                  Past Experiences / Employment Record / References - #2{" "}
                  <MandatorySymbol />
                </h4>
              </div>
              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      required={true}
                      disabled={false}
                      type="text"
                      placeholder="Past Employer"
                      name="form.last_employer2"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.last_employer2}
                      title="Past Employer #2"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      required={true}
                      disabled={false}
                      type="text"
                      placeholder="Position Held"
                      name="form.reference2Position"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Position}
                      title="Position at Past Experience #2"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <DatePicker
                      required={true}
                      title="Start date of Past Experience #2"
                      selected={this.state.form.reference2StartDate}
                      showYearDropdown
                      onChange={this.handleDateChange.bind(
                        this,
                        "form.reference2StartDate",
                      )}
                      placeholderText="Start Date MM/DD/YYYY"
                      dateFormat={util._datePickerFormat()}
                      maxDate={new Date()}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <DatePicker
                      required={true}
                      title="End date of Past Experience #2"
                      selected={this.state.form.reference2EndDate}
                      showYearDropdown
                      onChange={this.handleDateChange.bind(
                        this,
                        "form.reference2EndDate",
                      )}
                      placeholderText="End Date MM/DD/YYYY"
                      dateFormat={util._datePickerFormat()}
                      minDate={this.state.form.reference2StartDate}
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                    <input
                      required={true}
                      disabled={false}
                      type="text"
                      placeholder="Address"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Address}
                      name="form.reference2Address"
                      title="Location Address of Past Experience #2"
                    />
                  </div>
                  <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                    <input
                      required={true}
                      disabled={false}
                      type="text"
                      placeholder="City"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2City}
                      name="form.reference2City"
                      title="Location City of Past Experience #2"
                    />
                  </div>
                  <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                    <input
                      required={true}
                      disabled={false}
                      type="text"
                      placeholder="State"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2State}
                      name="form.reference2State"
                      title="Location State of Past Experience #2"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      required={true}
                      disabled={false}
                      type="text"
                      placeholder="Supervisors name"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Supervisor}
                      name="form.reference2Supervisor"
                      title="Supervisor at Past Experience #2"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      disabled={false}
                      type="text"
                      placeholder="Alternate contact name"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2AltContact}
                      name="form.reference2AltContact"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    {/* <input
                      type="text"
                      placeholder="Cell Phone"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Telephone}
                      name="form.reference2Telephone"
                    /> */}

                    <NumberFormat
                      placeholder="Cell Phone"
                      required={true}
                      disabled={false}
                      data-validation="phonenumber"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      name="form.reference2Telephone"
                      value={this.state.form.reference2Telephone}
                      format="(###) ###-####"
                      mask=""
                      title="Cell Phone of employer at Past Experience #2"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      type="text"
                      placeholder="Fax"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Fax}
                      name="form.reference2Fax"
                      data-validation="fax"
                      maxlength="20"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-section-head">
                <h4>Responsibilities</h4>
              </div>

              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-12 aplcn-inp-wrap aplcn-note-text-wrapper">
                    <textarea
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Responsibilities}
                      name="form.reference2Responsibilities"
                      placeholder="Please fill out your responsibilities for this position…"
                      title="Responsibilities at Past Experience #2"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-section-head">
                <h4>Reason For Leaving</h4>
              </div>

              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-12 aplcn-inp-wrap aplcn-note-text-wrapper">
                    <textarea
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2ResonForLeaving}
                      name="form.reference2ResonForLeaving"
                      placeholder="Please describe your reason for leaving…"
                      title="Reason for leaving employer of Past Experience #2"
                    />
                  </div>
                </div>
              </div>
            </div>
          }

          {/* <!-- section three --> */}

          {
            <div className="past-employer-section">
              <div className="aplcn-form-section-head">
                <h4>
                  Past Experiences / Employment Record / References - #3
                </h4>
              </div>
              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      required={false}
                      disabled={false}
                      type="text"
                      placeholder="Past Employer"
                      name="form.last_employer3"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.last_employer3}
                      title="Past Employer #3"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      required={false}
                      disabled={false}
                      type="text"
                      placeholder="Position Held"
                      name="form.reference3Position"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3Position}
                      title="Position at Past Experience #3"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <DatePicker
                      required={false}
                      disabled={false}
                      selected={this.state.form.reference3StartDate}
                      showYearDropdown
                      onChange={this.handleDateChange.bind(
                        this,
                        "form.reference3StartDate",
                      )}
                      placeholderText="Start Date MM/DD/YYYY"
                      dateFormat={util._datePickerFormat()}
                      maxDate={new Date()}
                      title="Start date of Past Experience #3"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <DatePicker
                      required={false}
                      disabled={false}
                      selected={this.state.form.reference3EndDate}
                      showYearDropdown
                      onChange={this.handleDateChange.bind(
                        this,
                        "form.reference3EndDate",
                      )}
                      placeholderText="End Date MM/DD/YYYY"
                      dateFormat={util._datePickerFormat()}
                      minDate={this.state.form.reference3StartDate}
                      title="End date of Past Experience #3"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                    <input
                      required={false}
                      disabled={false}
                      type="text"
                      placeholder="Address"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3Address}
                      name="form.reference3Address"
                      title="Location Address of Past Experience #3"
                    />
                  </div>
                  <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                    <input
                      required={false}
                      disabled={false}
                      type="text"
                      placeholder="City"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3City}
                      name="form.reference3City"
                      title="Location City of Past Experience #3"
                    />
                  </div>
                  <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                    <input
                      required={false}
                      disabled={false}
                      type="text"
                      placeholder="State"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3State}
                      name="form.reference3State"
                      title="Location State of Past Experience #3"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      required={false}
                      disabled={false}
                      type="text"
                      placeholder="Supervisors name"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3Supervisor}
                      name="form.reference3Supervisor"
                      title="Supervisor at Past Experience #3"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      disabled={false}
                      type="text"
                      placeholder="Alternate contact name"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3AltContact}
                      name="form.reference3AltContact"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <NumberFormat
                      placeholder="Cell Phone"
                      required={false}
                      disabled={false}
                      data-validation="phonenumber"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      name="form.reference3Telephone"
                      value={this.state.form.reference3Telephone}
                      format="(###) ###-####"
                      mask=""
                      title="Cell Phone of employer at Past Experience #3"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      disabled={false}
                      type="text"
                      placeholder="Fax"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3Fax}
                      name="form.reference3Fax"
                      data-validation="fax"
                      maxlength="20"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-section-head">
                <h4>Responsibilities</h4>
              </div>

              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-12 aplcn-inp-wrap aplcn-note-text-wrapper">
                    <textarea
                      required={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3Responsibilities}
                      name="form.reference3Responsibilities"
                      placeholder="Please fill out your responsibilities for this position…"
                      title="Responsibilities at Past Experience #3"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-section-head">
                <h4>Reason For Leaving</h4>
              </div>

              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-12 aplcn-inp-wrap aplcn-note-text-wrapper">
                    <textarea
                      required={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3ResonForLeaving}
                      name="form.reference3ResonForLeaving"
                      placeholder="Please describe your reason for leaving…"
                      title="Reason for leaving employer of Past Experience #3"
                    />
                  </div>
                </div>
              </div>
            </div>
          }

          {/* REFERENCES */}
          {/* <div className="personal-reference-one">
            <div className="aplcn-form-section-head">
              <h4>
                Professional Reference #1 <MandatorySymbol />
              </h4>
            </div>
            <div className="aplcn-form-row-main aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    title="Name of Professional Reference #1"
                    type="text"
                    placeholder="Name"
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1name}
                    name="form.reference1name"
                  />
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    title="Relationship with Professional Reference #1"
                    type="text"
                    placeholder="Relationship"
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1Relationship}
                    name="form.reference1Relationship"
                  />
                </div>
              </div>
            </div>

            <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
              <div className="row aplcn-row">
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">

                  <NumberFormat
                    placeholder="Cell Phone"
                    required={true}
                    disabled={false}
                    data-validation="phonenumber"
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    name="form.reference1Phone"
                    value={this.state.form.reference1Phone}
                    format="(###) ###-####"
                    mask=""
                    title="Cell Phone of Professional Reference #1"
                  />
                </div>
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    title="Period of knowing Professional Reference #1"
                    type="text"
                    placeholder="How long have you know them?"
                    required={true}
                    disabled={false}
                    onChange={this.setValue.bind(this)}
                    onBlur={this.blur.bind(this)}
                    value={this.state.form.reference1Known}
                    name="form.reference1Known"
                  />
                </div>
              </div>
            </div>
          </div>

          {
            <div className="personal-reference-one">
              <div className="aplcn-form-section-head">
                <h4>
                  Professional Reference #2 <MandatorySymbol />
                </h4>
              </div>
              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      type="text"
                      placeholder="Name"
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2name}
                      name="form.reference2name"
                      title="Name of Professional Reference #2"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      type="text"
                      placeholder="Relationship"
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Relationship}
                      name="form.reference2Relationship"
                      title="Relationship with Professional Reference #2"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <NumberFormat
                      placeholder="Cell Phone"
                      required={true}
                      disabled={false}
                      data-validation="phonenumber"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      name="form.reference2Phone"
                      value={this.state.form.reference2Phone}
                      format="(###) ###-####"
                      mask=""
                      title="Cell Phone of Professional Reference #2"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      title="Period of knowing Professional Reference #2"
                      type="text"
                      placeholder="How long have you know them?"
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference2Known}
                      name="form.reference2Known"
                    />
                  </div>
                </div>
              </div>
            </div>
          }

          {
            <div className="personal-reference-one">
              <div className="aplcn-form-section-head">
                <h4>
                  Professional Reference #3 <MandatorySymbol />
                </h4>
              </div>
              <div className="aplcn-form-row-main aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      title="Name of Professional Reference #3"
                      type="text"
                      placeholder="Name"
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3name}
                      name="form.reference3name"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      title="Relationship with Professional Reference #3"
                      type="text"
                      placeholder="Relationship"
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3Relationship}
                      name="form.reference3Relationship"
                    />
                  </div>
                </div>
              </div>

              <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
                <div className="row aplcn-row">
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <NumberFormat
                      placeholder="Cell Phone"
                      required={true}
                      disabled={false}
                      data-validation="phonenumber"
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      name="form.reference3Phone"
                      value={this.state.form.reference3Phone}
                      format="(###) ###-####"
                      mask=""
                      title="Cell Phone of Professional Reference #3"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                    <input
                      title="Period of knowing Professional Reference #3"
                      type="text"
                      placeholder="How long have you know them?"
                      required={true}
                      disabled={false}
                      onChange={this.setValue.bind(this)}
                      onBlur={this.blur.bind(this)}
                      value={this.state.form.reference3Known}
                      name="form.reference3Known"
                    />
                  </div>
                </div>
              </div>
            </div>
          } */}

          <div className="row">
            <div className="col-sm-12 aplcn-form-main-actionbar">
              <div className="aplcn-form-actionbar">
                <button
                  onClick={this.back.bind(this)}
                  type="button"
                  disabled=""
                  className="aplcn-prev-button"
                >
                  Previous
                </button>
                <button type="submit" className="aplcn-next-btn">
                  Next
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
  back(event) {
    event.preventDefault();
    this.props.back(step);
  }
}
function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(Experience);
export { connectedApp as Experience };
